export default __webpack_public_path__ + "static/media/a2.cdaabf87.png";